import { IonLoading, IonToast } from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";
import { findAssignedUsers } from "../../../store/formsubmitted/actions/findAssignedUsers";
import { RootState } from "../../../store/rootReducer";

export const AssignUsersStatus = () => {
    const dispatch = useDispatch();
    const assignUsersStatus = useSelector((state: RootState) => state.formSubmittedSlice.assignUsersStatus);
    const formId = useSelector((state: RootState) => state.templateDetail.template.id);

    const handleFinishedAssign = () => {
        dispatch(findAssignedUsers({ formId: formId.toString() }));
    }

    return (
        <>
            <IonLoading isOpen={assignUsersStatus === "pending"} message={"Guardando información..."} />

            {assignUsersStatus === "succeeded" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Los usuarios fueron asignados correctamente"
                    position="bottom"
                    duration={2000}
                    color="success"
                />
            )}

            {assignUsersStatus === "failed" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Ocurrió un error al asignar a los usuarios"
                    position="bottom"
                    duration={2000}
                    color="danger"
                />
            )}
        </>
    );
};
